import { useCallback, useState } from 'react';
import { SxProps } from '@mui/material';

import { SurveyLocationStatisticsFragment } from '@occc/graphql';

import { SurveyStatisticsBarChartItem, SurveyStatisticsPieChartItem } from './types';
import { LocationRowChart } from './LocationRowChart';
import { headers } from './SurveyLocationsTableHead';

import { ExpandableTableRow, TableCell } from '../../../design-system';
import { separateEveryThousandByComma } from '../../../lib/numbers';

type SurveyLocationTableBodyExpandableRowProps = {
  responseStatisticsPerLocation: SurveyStatisticsPieChartItem | SurveyStatisticsBarChartItem;
  location: SurveyLocationStatisticsFragment;
};

export const SurveyLocationTableBodyExpandableRow = ({
  location: {
    siteId,
    siteName,
    topResponse,
    topResponsePercentage,
    bottomResponse,
    bottomResponsePercentage,
    totalResponses,
  },
  responseStatisticsPerLocation,
}: SurveyLocationTableBodyExpandableRowProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleOnClick = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);
  const borderBottomStyles: SxProps = { borderBottom: isExpanded ? 'none' : undefined };

  const areResponsesSpreadEvenly = topResponsePercentage === bottomResponsePercentage;

  return (
    <ExpandableTableRow
      isExpanded={isExpanded}
      onClick={handleOnClick}
      arrowCellSx={borderBottomStyles}
      expandedContent={
        <LocationRowChart {...responseStatisticsPerLocation} columnsCount={headers.length} />
      }
    >
      <TableCell sx={borderBottomStyles}>{siteId}</TableCell>
      <TableCell sx={borderBottomStyles}>{siteName}</TableCell>
      <TableCell sx={borderBottomStyles}>{separateEveryThousandByComma(totalResponses)}</TableCell>
      <TableCell sx={borderBottomStyles}>
        {areResponsesSpreadEvenly ? 'Even Split' : `${topResponse} (${topResponsePercentage}%)`}
      </TableCell>
      <TableCell sx={borderBottomStyles}>
        {areResponsesSpreadEvenly
          ? 'Even Split'
          : `${bottomResponse} (${bottomResponsePercentage}%)`}
      </TableCell>
    </ExpandableTableRow>
  );
};
